import React, { Component } from "react";
import PropTypes from "prop-types";
import {
  addActivity,
  removeActivity,
  resendActivityDetails,
  loadShopActivityDetails,
  resetReload,
  MY_ACTIVITIES_RESEND_SUCCESS,
} from "actions/shopActivitiesActions";
import { connect } from "react-redux";
import { Button, Loader } from "cxa-components";
import { Link } from "react-router-dom";
import { FormattedCustomDate } from "components/common/FormattedComponents";
import moment from "moment";
import lodash from "lodash";
import { intlShape, injectIntl, FormattedMessage } from "react-intl";
import messages from "components/messagesDescription";
import { compose, withHandlers, withState } from "recompose";
import CancelDialog from "./CancelDialog";
import SignUpDialog from "./SignUpDialog";
import { showToast } from "actions/toastActions";

const mapStateToProps = function(store, ownProps) {
  const { fetching: processing, error, shouldReload, resendStatus } = store.shopActivity;
  const {
    shopActivityDetails: { data: activity, fetching },
  } = store;

  return {
    activity,
    fetching,
    activityId: ownProps.match.params.activityId,
    processing,
    error,
    shouldReload,
    resendStatus,
  };
};

const mapDispatchToProps = {
  addActivity,
  removeActivity,
  resendActivityDetails,
  loadShopActivityDetails,
  resetReload,
  showToast,
};

const enhanceActivityDetails = compose(
  injectIntl,
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  withState("isDeleteItemModalOpen", "toggleDeleteItemModal", false),
  withState("isSignUpModalOpen", "toggleSignUpModal", false),
  withHandlers({
    openDeleteItemModal: props => () => props.toggleDeleteItemModal(true),
    closeDeleteItemModal: props => () => props.toggleDeleteItemModal(false),
    openSignUpModal: props => () => props.toggleSignUpModal(true),
    closeSignUpModal: props => () => props.toggleSignUpModal(false),
  })
);

class ActivityDetails extends Component {
  static propTypes = {
    activityId: PropTypes.string.isRequired,
    signupId: PropTypes.number,
    activity: PropTypes.object,
    addActivity: PropTypes.func,
    removeActivity: PropTypes.func,
    resendActivityDetails: PropTypes.func,
    processing: PropTypes.bool,
    error: PropTypes.object,
    showStatus: PropTypes.bool,
    showCount: PropTypes.bool,
    showProvider: PropTypes.bool,
    showDownload: PropTypes.bool,
    fetching: PropTypes.bool,
    resetReload: PropTypes.func,
    loadShopActivityDetails: PropTypes.func,
    shouldReload: PropTypes.bool,
    isDeleteItemModalOpen: PropTypes.bool,
    openDeleteItemModal: PropTypes.func,
    closeDeleteItemModal: PropTypes.func,
    isSignUpModalOpen: PropTypes.bool,
    openSignUpModal: PropTypes.func,
    closeSignUpModal: PropTypes.func,
    intl: intlShape.isRequired,
    resendStatus: PropTypes.string,
    showToast: PropTypes.func,
  };

  signUp = activityId => {
    const { addActivity, closeSignUpModal } = this.props;

    addActivity(activityId);
    closeSignUpModal();
  };

  removeActivity = (activityId, code) => {
    const { removeActivity, closeDeleteItemModal } = this.props;

    removeActivity(activityId, code);
    closeDeleteItemModal();
  };

  reloadData = () => {
    const { activityId, resetReload, loadShopActivityDetails } = this.props;

    resetReload();
    loadShopActivityDetails(activityId);
  };

  componentDidMount() {
    this.reloadData();
  }

  componentDidUpdate() {
    if (this.props.shouldReload) {
      this.reloadData();
    }
  }

  componentWillReceiveProps(nextProps) {
    const { resendStatus } = nextProps;
    const { intl, showToast, resendStatus: prevResend } = this.props;

    if (prevResend !== resendStatus && resendStatus === MY_ACTIVITIES_RESEND_SUCCESS) {
      showToast({
        message: intl.formatMessage(messages.voucherResendNotification),
      });
    }
  }

  resendVoucher = code => {
    const { activity } = this.props;

    this.props.resendActivityDetails(activity.activityId, code);
  };

  render() {
    const {
      activity,
      fetching,
      error, // this doesn't seem to be set properly and don't have time to look into it right now
      signupId,
      isDeleteItemModalOpen,
      openDeleteItemModal,
      closeDeleteItemModal,
      isSignUpModalOpen,
      openSignUpModal,
      closeSignUpModal,
      intl,
    } = this.props;

    if (fetching || !activity) {
      return <Loader />;
    }

    const { userSignUps = [], activityId, locationDetailsList = [] } = activity;

    let signup = lodash.find(userSignUps, signup => signup.signUpId === signupId);

    if ((!signupId || signupId === 0) && userSignUps.length > 0) {
      signup = userSignUps[0];
    }

    const fullActivity = Object.assign({}, activity, signup);
    const startDate = moment(fullActivity.eventStartDate);
    const endDate = moment(fullActivity.eventEndDate);
    const signUpEndDate = moment(fullActivity.signUpEndDate);
    const dateDiff = endDate.diff(startDate, "days");
    const statusGroup = fullActivity.statusGroup;

    let canSignup = !fullActivity.hasLimitedSignUps;
    let canCancel = fullActivity.signUpCode && fullActivity.signUpCode.length > 0;

    if (fullActivity.hasLimitedSignUps) {
      canSignup =
        (fullActivity.signUpsAvailable > 0 &&
          fullActivity.signUpsAvailable >= fullActivity.signUpLimitPerUser &&
          (!fullActivity.userSignUps ||
            fullActivity.signUpLimitPerUser > fullActivity.userSignUps.length)) ||
        fullActivity.signUpLimitPerUser === 0;
    }

    if (canCancel) {
      canCancel = signUpEndDate.diff(new Date(), "minutes") > 0 && statusGroup === "Outstanding";
    }

    const locationDetails = providerlocation => {
      const locations = Object.keys(providerlocation).map(key => {
        if (key === "phoneNumber" || key === "emailAddress") {
          const splitKey = key.replace(/([A-Z])/g, " $1").split(" ");
          const formattedKey = splitKey[0].charAt(0).toUpperCase() + splitKey[0].slice(1);
          return (
            <span key={key}>
              {intl.formatMessage({
                id: formattedKey,
                defaultMessage: formattedKey,
              })}{" "}
              {providerlocation[key]}
              <br />
            </span>
          );
        }

        return (
          <span key={key}>
            {providerlocation[key]}
            <br />
          </span>
        );
      });

      return <dd>{locations}</dd>;
    };

    return (
      <article className="card">
        <CancelDialog
          isOpen={isDeleteItemModalOpen}
          activityName={fullActivity.activityName}
          closeDeleteItemModal={closeDeleteItemModal}
          removeActivity={this.removeActivity}
          activityId={activityId}
          signUpCode={fullActivity.signUpCode}
        />
        <SignUpDialog
          isOpen={isSignUpModalOpen}
          activityName={fullActivity.activityName}
          closeDeleteItemModal={closeSignUpModal}
          activitySignUp={this.signUp}
          activityId={activityId}
        />
        <header>
          <h3>{fullActivity.activityName}</h3>
          <p className="apl-activity__provider">by {fullActivity.providerName}</p>
          <dl className="apl-activity__details">
            <div>
              <dt>
                <FormattedMessage {...messages.whenDescription} />
              </dt>
              <dd>
                <FormattedCustomDate value={fullActivity.eventStartDate} />{" "}
                {dateDiff > 0 && <FormattedCustomDate value={fullActivity.eventEndDate} />}
              </dd>
            </div>
            <div>
              <dt>
                <FormattedMessage {...messages.timeDescription} />
              </dt>
              <dd>{startDate.format("HH:mm")}</dd>
            </div>
            <div>
              <dt>
                <FormattedMessage {...messages.venueDescription} />
              </dt>
              {locationDetailsList.map(providerLocation => locationDetails(providerLocation))}
            </div>
          </dl>
        </header>
        <section>
          <div className="cxa-grid__wrapper">
            <div className="cxa-grid__item cxa-grid__item--three">
              <img src={fullActivity.imageUri} alt="" />
            </div>

            <div className="cxa-grid__item cxa-grid__item--nine">
              {fullActivity.hasEmployeeWarning && (
                <div
                  dangerouslySetInnerHTML={{
                    __html: fullActivity.employeeWarning,
                  }}
                />
              )}
              <div dangerouslySetInnerHTML={{ __html: fullActivity.description }} />
              <div dangerouslySetInnerHTML={{ __html: fullActivity.whatsIncluded }} />
            </div>
          </div>
        </section>
        <footer>
          <p>
            {canSignup && (
              <Button primary type="button" onClick={openSignUpModal}>
                {intl.formatMessage(messages.signUpDescription)}
              </Button>
            )}
            {canCancel && (
              <Button primary type="button" onClick={() => this.resendVoucher(fullActivity.signUpCode)}>
                {intl.formatMessage(messages.resendVoucherDescription)}
              </Button>
            )}
            {canCancel && (
              <Link
                className="button button--secondary"
                to={fullActivity.voucherDownloadUrl}
                target="_blank"
                rel="noopener noreferrer"
              >
                {intl.formatMessage(messages.downloadDescription)}
              </Link>
            )}
            {canCancel && (
              <Button type="button" tertiary onClick={openDeleteItemModal}>
                {intl.formatMessage(messages.cancelSignUpDescription)}
              </Button>
            )}
          </p>
        </footer>
      </article>
    );
  }
}

export default enhanceActivityDetails(ActivityDetails);



// WEBPACK FOOTER //
// ./components/wellness/activities/activityDetails.jsx